import React, { useEffect } from "react";
import "./App.css";
import MainApp from "./app/MainApp";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import AlertsHandler from "./features/Alerts";
import useDesktopSize from "./utils/hooks/useDesktopSize";
import useThemeColor from "./utils/hooks/useThemeColor";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { pl } from "date-fns/locale";
import useFakeSession from "./utils/hooks/useFakeSession";
import { useDispatch } from "react-redux";
import { getConfigurationFacility } from "./app/store/config/configActions";
import useFacility from "./utils/hooks/useFacility";
import { ConfirmProvider } from "material-ui-confirm";

const App: React.FC = () => {
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const isDesktop = useDesktopSize();
  useThemeColor();
  useFakeSession();

  useEffect(() => {
    dispatch(getConfigurationFacility(facilityIds));
      //eslint-disable-next-line
  }, []);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={pl}>
      <ReactNotification isMobile={!isDesktop} />
      <AlertsHandler />
      <ConfirmProvider
        defaultOptions={{
          cancellationText: "Anuluj",
          confirmationText: "Akceptuj",
        }}
      >
        <MainApp />
      </ConfirmProvider>
    </MuiPickersUtilsProvider>
  );
};

export default App;
